import { api } from "./axios";

// User related endpoints
export const userApi = {
  getProfile: () => api.get("/users/me"),
  updateProfile: (data: any) => api.put("/users/update-profile", data),
  updatePassword: (data: any) => api.put("/users/update-password", data),
  deleteAccount: (userId: number) => api.delete(`/users/${userId}`),
  uploadProfilePicture: (data: FormData) =>
    api.post("/users/profile-picture", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  exportData: () => api.get("/users/export-data"),
};
